module.exports = __webpack_public_path__ + "img/bg-squre.a2963eeb.png";